const testimonials = [
  {
    name: "VP Operations, Williams Companies",
    location: "Downtown Tulsa, OK",
    rating: 5,
    text: "I received a last-minute assignment to Abu Dhabi and realized my passport had expired during COVID when I was not traveling. Fast Passport Center had my renewal processed and back to me in four business days. I made my flight out of TUL without any issues. Incredibly professional team — they understood the urgency immediately and kept me updated throughout.",
    service: "Emergency Renewal",
  },
  {
    name: "Pastor Mike H.",
    location: "Jenks, OK",
    rating: 5,
    text: "We had 14 youth heading to Guatemala on a mission trip and discovered three passports had expired two months out. Two of the kids had never had passports. Fast Passport Center handled the group coordination, walked parents through the child passport process, and got all five passports back in seven business days. Our team made the trip. Cannot thank them enough.",
    service: "Group Mission Trip Processing",
  },
  {
    name: "Emily W.",
    location: "ORU Campus, Tulsa",
    rating: 5,
    text: "I was accepted into ORU's Global Learning program to Kenya and realized I had never applied for a passport. First-time applications are more complex than renewals, and I was nervous about the timeline. Fast Passport Center guided me through the Tulsa Post Office acceptance clerk step, sent me a complete checklist, and got my passport back in six business days. Made my orientation with time to spare.",
    service: "First-Time Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TulsaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Northeast Oklahoma Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Tulsa, Jenks, Bixby, and Broken Arrow travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}